import React from "react"
import Seo from "../components/seo"
import Layout from "../components/layout"
import { Link } from "gatsby"
import "../styles/pc/page/terms.scss"
import "../styles/sp/page/terms.scss"

export default function TermsPage() {
  return (
    <Layout>
      <Seo
        type="article"
        title="利用規約"
        description=""
        bobyClassName="menu18"
        path="terms"
      />
      <div className="wrapper">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/terms" className="current">Terms</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}

        {/*//////////////////////////////* ↓タイトル * //////////////////////////////*/}
        <div className="catch1">
          <div className="catch1_in">
            <div className="catch_title">
              <h2 className="maintitle"><span>Terms</span></h2>
              <p className="subtitle"><span>利用規約</span></p>
            </div>
          </div>{/* catch_in */}
        </div>{/* /catch1 */}
        {/*//////////////////////////////* ↑タイトル * //////////////////////////////*/}
        <div className="wrapper_contents">
          <div className="main">
        {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
        <div className="contents contents_wrap">
          <div className="contents_in">
            <div className="padding_sp">{/* スマホのみ隙間 */}
              <div className="terms_cnt_wrap w730">
                {/*<div class="inner_title">
		<div class="inner_title_in">
			<!--<p class="subtitle"><span></span></p>
			<h4 class="maintitle"><span></span></h4>
		</div>*/}
                <div className="cnt_wrap">
                  <p>このサイトは株式会社Ｊ-Feelが運営しています。このサイトをご利用される際には、以下のご利用条件をよくお読み下さい。なお、サイトの利用にあたっては、これらの条件にご同意されたものとみなします。
                  </p>
                </div>
                <div className="cnt_wrap">
                  {/*<div class="inner_title">
            <div class="inner_title_in">
                <h5 class="maintitle_left"><span></span></h5>
            </div>
            </div>*/}
                  <dl className="terms_box">
                    <dt>1. 著作権等の権利について</dt>
                    <dd>このサイトに掲載されている文章、画像等すべての情報の著作権・肖像権は、(株)J.Feelまたはその他の権利者に帰属します。</dd>
                  </dl>
                  <dl className="terms_box">
                    <dt>2. 禁止事項について</dt>
                    <dd>このサイトのご利用に際して、次の行為を禁止事項とさせて頂きます。<br /><br />
                      ・(株)J.Feel或いは第三者の著作権・知的財産権・肖像権・プライバシー等を侵害する行為、または侵害する恐れのある行為。<br />
                      ・(株)J.Feel或いは第三者の名誉もしくは信用を毀損する行為。<br />
                      ・(株)J.Feel或いは第三者に不利益もしくは損害を与える行為、またはその恐れのある行為。<br />
                      ・不正に他人の電子メールアドレスを利用する行為や虚偽の申告、届出を行なう行為。<br /><br />
                      ・サーバーへの不正アクセス、或いはコンピューターウイルス・スパイウイルスなどの有害なプログラムを使用・提供し、(株)J.Feel或いは第三者に損害を与える行為
                      ・営業活動或いは営利を目的とする行為<br />
                      ・その他、法律、法令に違反する行為</dd>
                  </dl>
                  <dl className="terms_box">
                    <dt>3. 免責事項について</dt>
                    <dd>
                      <ul>
                        <li>(1) このサイトに掲載されている情報に関する事項
                          <ul className="box">
                            <li>掲載情報に関しましては、その正確性、有用性、確実性を保証するものではありません。掲載情報を利用すること、もしくは利用できなかったことにより生じる損害について(株)J.Feelは責任を一切負いません。</li>
                          </ul>
                        </li>
                        <ul>
                          <li>(2) このサイトのシステムに関する事項
                            <ul className="box">
                              <li>サイトの管理に関しては細心の注意を払っておりますが、予測できない攻撃（コンピューターウィルスその他の悪意的・有害的な攻撃）や確実性（不具合やエラー・障害の発生が起きないこと）につきましては、保証を致してしておりません。このサイトをご利用になったことにより生じる損害についても(株) J.Feelは責任を一切負いかねますので、ご了承願います。</li>
                            </ul>
                          </li>
                        </ul>
                        <ul>
                          <li>(3) サイトの運営に関して
                            <ul className="box">
                              <li>(株)J.Feelは予告なしに、サイト上の情報を変更することがあります。また、サイトの運営を中断或いは中止させて頂く場合もあります。尚、情報の変更或いはサイトの運用中断または中止によって生じる損害についても(株)J.Feelは一切責任を負いません。</li>
                            </ul>
                          </li>
                        </ul>
                        <br /><br />
                        お客様は、これら免責事項をご認識の上、お客さま自身の責任において当サイトをご利用いただきますようお願い申し上げます。</ul></dd>
                  </dl>
                  <dl className="terms_box">
                    <dt>4. お客様からの情報提供について</dt>
                    <dd>本サイトにおいて、お客さまから情報、コメントを募集する場合があります。この場合、お寄せ頂いた情報等の取り扱いについては、当該情報の応募要領及び下記規則に従います。<br /><br />
                    </dd><dd className="bottom_40px">上記以外に、お客さまの方から(株)J.Feelに情報（論文、アイデア、コンセプト、図画、情報源など）をお送り頂くことは固くお断り申し上げております。<br />
                      もしお送り頂いた場合は、お客様が下記規則をご了承の上、提供されたとみなされますことをあらかじめご了承願います。</dd>
                    <ul>
                      <li>【規則】
                        <ul className="box">
                          <li>(1) お送り頂いた情報等について、お客様は著作権その他いかなる権利も放棄したとみなします。</li>
                          <li>(2) お送り頂いた情報等について(株)J.Feelは内容の検討、掲載の可否、採用の義務を一切負いません。</li>
                          <li>(3) お送り頂いた情報等に関して、(株)J.Feelは秘密保持の義務を一切負いません。</li>
                          <li>(4) お送り頂いた情報等については、(株)J.Feelがその全部または一部を自由に利用できることとします。</li>
                          <li>(5) お送り頂いた情報等の全部または一部と、同一または類似するサービス・商品などを(株)J.Feelが発表・公表した場合も、(株)J.Feelは情報等をお送り頂いたお客さま或いはその他第三者に対して、対価の支払いその他一切の責任も負いません。</li>
                        </ul>
                      </li>
                    </ul></dl>
                  <dl className="terms_box">
                    <dt>5. リンクサイトについて</dt>
                    <dd>このサイトから、リンクをしているウェブサイトの内容は、各社の責任で独自に運用されているものであります。(株)J.Feelはリンクサイトの内容について、またリンクサイトをご利用になったことで生じた如何なる損害についても、責任も一切負いません。</dd>
                  </dl>
                  <dl className="terms_box">
                    <dt>6. プライバシーポリシーについて</dt>
                    <dd>お客さまの個人情報の取得および使用、保護に関する(株)J.Feelのポリシーに関しましては、「<Link to="/policy">プライバシーポリシー</Link>」をご覧ください。</dd>
                  </dl>
                </div>
              </div>
            </div>{/* padding_sp スマホのみ隙間 */}
          </div>{/* contents_in */}
        </div>{/* /contents */}
        {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
          </div>{/* main */}
          <div className="page_title fixed">
            <div className="right_page_ttl"><span className="vertical">Terms - </span><span className="txt">利用規約</span></div>
          </div>{/* right page_title */}
        </div>{/*wrapper_contents*/}
      </div>{/*wrapper*/}
    </Layout>
  )
}
